export const STORES_URLS = 'https://lilibanking.page.link/open';

export const GO_TO_APP_STYLES = {
  WRAPPER: 'h-screen min-h-[835px] w-screen flex tablet:items-center justify-center',
  MARGIN_FOR_SIDEBAR: 'pl-[5.5rem]',
  CONTAINER:
    ' flex my-auto justify-center items-center px-8 py-14 tablet:px-14 h-[42rem] tablet:pt-24  tablet:h-[38rem] tablet:py-12 pc-sm:pt-[2.875rem] pb-[4.688rem] w-[90%] pc-sm:min-h-[33.188rem] tablet:w-[90%] bg-bw00 rounded-xl tablet:max-w-[588px] relative shadow-light font-metric',
  CONTENT_CONTAINER: 'my-auto h-full flex flex-col items-center text-center',
  LILI_LOGO: 'h-[60px] w-[95px]',
  PHONE_ICON:
    ' mb-5 pc-sm:mb-5 h-[140px] w-[183px] tablet:h-[166px] tablet:w-[217px] mt-[1.688rem] tablet:mt-[2.525rem] pc-sm:mt-[3.438rem]',
  TEXT_CONTAINER:
    ' tablet:px-[2.188rem] mt-[1.688rem] tablet:mt-[2.188rem] pc-sm:mt-[4rem] tablet:px-0 phone:mb-2 pc-sm: mb-0',
  TEXT_1: 'font-metricMedium text-[1.75rem] text-bw08 leading-[2rem] tablet:leading-[2.375rem]',
  TEXT_2: 'text-bw07 font-metric mt-1.5 text-base leading-[1.5rem] tablet:leading-[2.375rem]',
  STORES_CONTAINER:
    'flex flex-col absolute bottom-8 gap-iconsMobile tablet:gap-iconsTablet tablet:flex-row tablet:block tablet:flex',
  STORE_ICON: 'w-[183px] h-[60px] cursor-pointer',
};

export const TEXTS = {
  TEXT_1: 'GO_TO_APP_TEXT_1',
  TEXT_1_INVOICE: 'GO_TO_APP_TEXT_1_INVOICE',
  TEXT_2_INVOICE: 'GO_TO_APP_TEXT_2_INVOICE',
  TEXT_2_TABLET: 'GO_TO_APP_TEXT_2_TABLET',
} as const;
